import { Injectable } from '@angular/core';
import { IHotel } from '../../../models/hotel';
import { IOverlay } from './IOverlay';

@Injectable()
export class IqbhMapService {
    public prepareOverlays(properties: IHotel[]): IOverlay[] {
        return properties
            .filter((property: IHotel) => property && property.geoposition)
            .map((property: IHotel): IOverlay => {
                return {
                    position: {
                        lat: Number(property.geoposition.latitude),
                        lng: Number(property.geoposition.longitude)
                    },
                    data: {
                        property: property.syscode,
                        trip: property.trip,
                        hotel: property
                    },
                    id: property.property
                };
            });

    }
}
